import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    checkExistingUser,
    ExistingUserCheckModel,
    OnePageCheckExistingUser,
} from "@sunSource/Services/OnePageCheckoutExistingUserLookupService";

type HandlerType = ApiHandler<OnePageCheckExistingUser, ExistingUserCheckModel>;

export const RequestExistingUserCheck: HandlerType = async props => {
    const result = await checkExistingUser(props.parameter);
    props.apiResult = result;
};

const userCheckChain = [RequestExistingUserCheck];

const checkUserExists = createHandlerChainRunner(userCheckChain, "CheckUserExistsByEmail");
export default checkUserExists;
